// extracted by mini-css-extract-plugin
module.exports = {"lds-dual-ring":"LoadingSpinner_lds-dual-ring__1gtwA","loading-spinner__overlay":"LoadingSpinner_loading-spinner__overlay__2XdD4"};